// import React from 'react'
import './MonthlyBankStatement.css'
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { initializePendingAttendance, getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { getStates, fetchMonths, getDistrict, getProjects, getPendingAttendance, verifyAttendanceBulk } from '../../../services/monthlyAttendanceService';
import { getBankStatementReport } from '../../../services/salaryStructureService';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { capitalizeFirstLetter } from '../../../utils/validations';
const MonthlyBankStatement = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(null);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [bankStatement, setEpfWages] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);


    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const yearInputRef = useRef(null);
    const isFetchDataEnabled = state && month && year;
    const [selected, setSelected] = useState('');


    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label:capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);




    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
            setEpfWages([]);
            setHasFetched(false); // Reset fetch status
        }
    }, [state]);

    // Clear esic data and fetch status when any dropdown changes
    // useEffect(() => {
    //     const fetchProjects = async () => {
    //         try {

    //             const data = await getProjects();
    //             setProjectResponse(
    //                 data.map(pro => ({
    //                     value: pro.id,
    //                     label: pro.projectCode,
    //                 }))
    //             );
    //         } catch (error) {
    //             console.error('Error fetching projects:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
    //         }
    //     };
    //     if (!effectRan.current) {
    //         fetchProjects();
    //     }
    //     return () => {
    //         effectRan.current = true;
    //     }
    // }, [state, district, year]);


    // Clear esic data and fetch status when any dropdown changes
    useEffect(() => {
        setEpfWages([]);
        setOriginalData([]);
        setHasFetched(false);
    }, [state, month, year]); // ✅ Add project to depende


    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'district':
                setDistrict(value);
                setProject(null); // ✅ Clear project when district changes
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };


    const handleYearChange = (date) => {
        const newYear = date ? date.getFullYear() : null;
        setYear(newYear);
        setMonth(null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            // build params dynamically
            const params = {
                stateId: state,   // required
                month,
                year,
            };

            if (district) {
                params.districtId = district; // only include if provided
            }
            if (project) {
                params.projectId = project; // only include if provided
            }
            const response = await getBankStatementReport(params);
            const data = Array.isArray(response.data) ? response.data : [response.data];

            console.log("API response:", data);

            setHasFetched(true);
            setOriginalData(data);

            const initializedData = initializePendingAttendance(data, month, year);

            setEpfWages(initializedData);

            if (initializedData.length === 0) {
                alert("No employees found for the selected criteria.");
            } else {
                alert("EPS Wages data fetched successfully!");
            }
        } catch (error) {
            console.error("Error fetching bank data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch bank data",
            }));
            setHasFetched(true);
            alert("Failed to fetch bank data. Please try again.");
        }
    };



    const handleClear = () => {
        setDistrict('');
        setState('');
        setMonth('');
        setYear('');
        setProject('');
        setSelected('');
    }

    const gotoDashboard = () => {
        navigate('/dashboard');
    };


    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);

    const generateExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("bankStatement Attendance");

        // Title
        worksheet.mergeCells("A1:H1");
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Salary Disbursement";
        titleCell.font = { size: 16, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };

        // Headers
        const headers = [
            "S.No",
            "Debit Acc No",
            "Beneficiary Acc No",
            "Beneficiary Name",
            "Amount",
            "Pay Mode",
            "Date",
            "IFSC",
        ];

        worksheet.addRow(headers);

        // Style header
        const headerRow = worksheet.lastRow;
        headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
        headerRow.alignment = { horizontal: "center" };
        headerRow.eachCell((cell) => {
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // Column widths (adjusted)
        worksheet.columns = Array(headers.length).fill({ width: 20 });
        worksheet.getColumn(1).width = 6; // S.No smaller

        // ✅ Use the same data as your UI
        if (!bankStatement || bankStatement.length === 0) {
            worksheet.addRow(["No employee data available"]);
        } else {
            bankStatement.forEach((row, index) => {
                worksheet.addRow([
                    index + 1,
                    '000805023766',
                     row.accountNumber || "",
                    `${row.accountHolderName}`,
                    row.amount || "",
                    row.paymentMode || "",
                    formatDate(new Date()),
                    row.ifscCode || "",

                ]);
            });
        }

        // Align all data center-left for better readability
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 2) {
                row.eachCell((cell) => {
                    cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" },
                    };
                    cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
                });
            }
        });
      const monthName = monthOptions.find((m) => m.value === month)?.label || "Unknown";
        // Download Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `4Gid_${monthName}_${year}_BH_Salary.xlsx`;
        link.click();
    };
    const generatePDF = () => {
        if (!bankStatement || bankStatement.length === 0) {
            alert("No employee data available to export!");
            return;
        }

        const doc = new jsPDF("landscape"); // Landscape for wide tables

        // Title
        doc.setFontSize(16);
        doc.text("Salary Disbursement", 140, 15, { align: "center" });

        // Define table headers
        const headers = [
            [
                "S.No",
                "Debit Acc No",
                "Beneficiary Acc No",
                "Beneficiary Name",
                "Amount",
                "Pay Mode",
                "Date",
                "IFSC",
            ],
        ];

        // Map your bankStatement data to table rows
        const data = bankStatement.map((row, index) => [
            index + 1,
            '000805023766',
            (row.accountNumber).trim() || "",
            `${(row.accountHolderName).trim()}`,
            (row.amount).trim() || "",
            (row.paymentMode).trim() || "",
            formatDate(new Date()).trim(),
            (row.ifscCode).trim() || "",

        ]);

        // Add table using autotable
        doc.autoTable({
            startY: 25,
            head: headers,
            body: data,
            theme: "grid",
            headStyles: {
                fillColor: [68, 114, 196], // same blue as Excel header
                textColor: 255,
                halign: "center",
                fontStyle: "bold",
            },
            bodyStyles: { halign: "left", valign: "middle" },
            styles: { fontSize: 9, cellPadding: 2 },
            alternateRowStyles: { fillColor: [245, 247, 251] },
        });

        // Footer (optional)
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(
                `Page ${i} of ${pageCount}`,
                doc.internal.pageSize.width - 30,
                doc.internal.pageSize.height - 10
            );
        }

        // Download
        doc.save("Monthly_Salary_Bank_Statement.pdf");
    };
    const formatDate = (dateStr) => {
        if (!dateStr) return "—";
        const date = new Date(dateStr);
        if (isNaN(date)) return "Invalid Date";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <div className="bankStatement-esic-container">
            <div className="bankStatement-esic-box">
                <h2 className="bankStatement-esic-heading">Salary Disbursement</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="bankStatement-esic-maincontainer">
                        <div className="bankStatement-esic-container-part">
                            <div className={`bankStatement-esic-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="bankStatement-esic-container-part">
                            {/* <div className={`bankStatement-esic-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>District </label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div> */}
                        </div>
                    </div>
                    <div className="bankStatement-esic-maincontainer">
                        <div className="bankStatement-esic-container-part">
                            <div className={`bankStatement-esic-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="bankStatement-esic-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}
                                />
                                <label> <span className="required">*</span>Year </label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="bankStatement-esic-container-part">
                            <div className={`bankStatement-esic-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Month </label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    {/* <div className="bankStatement-esic-maincontainer">

                        <div className="bankStatement-esic-container-part">
                            <div className={`bankStatement-esic-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Project </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>
                        <div className="bankStatement-esic-container-part">

                        </div>
                    </div> */}
                    <div className="bankStatement-esic-btn-div">
                        <button
                            type="submit"
                            className="bankStatement-esic-btn"
                            disabled={!isFetchDataEnabled}
                        >
                            Fetch Data
                        </button>
                    </div>
                </form>
            </div>

            <div className="bankStatement-report-btn-div">
                <button
                    type="button"
                    className="bankStatement-report-btn"
                    onClick={generateExcel}
                    disabled={bankStatement.length === 0}  // ✅ disabled if no data
                >
                    Download Excel
                </button>
                {/* <button
                        type="button"
                        className="bankStatement-report-btn"
                        onClick={generatePDF}
                        disabled={bankStatement.length === 0}  // ✅ disabled if no data
                    >
                        Download PDF
                    </button> */}
            </div>

            <div className="esic-table-container">
                <table className="esic-table">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Debit Acc No</th>
                            <th>Beneficiary Acc No</th>
                            <th>Beneficiary Name</th>
                            <th>Amount</th>
                            <th>Pay Mode</th>
                            <th>Date</th>
                            <th>IFSC</th>
                        </tr>
                    </thead>
                    {hasFetched && (
                        <tbody>
                            {bankStatement.length === 0 ? (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center', padding: '10px' }}>No data available</td>
                                </tr>
                            ) : (
                                bankStatement.map((row, index) => {

                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>000805023766</td>
                                            <td>{row.accountNumber}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{row.accountHolderName}</td>
                                            <td>{row.amount}</td>
                                            <td>{row.paymentMode}</td>
                                            <td>{formatDate(new Date())}</td>
                                            <td>{row.ifscCode}</td>

                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    )}
                </table>


            </div>

        </div>
    );
};

export default MonthlyBankStatement;